module.exports = __webpack_public_path__ + "static/media/Calender.e5ccbdf6.svg";